import isNil from 'lodash-es/isNil'

export function getObj (key) {
    const item = sessionStorage.getItem(key)
    if (!isNil(item)) {
        return JSON.parse(item)
    }
    return null
}

export function getObjPersisted (key) {
    const item = localStorage.getItem(key)
    if (!isNil(item)) {
        return JSON.parse(item)
    }
    return null
}

export function getStrPersisted (key) {
    return localStorage.getItem(key)
}

export function setObj (key, obj) {
    sessionStorage.setItem(key, JSON.stringify(obj))
}

export function setObjPersisted (key, obj) {
    localStorage.setItem(key, JSON.stringify(obj))
}

export function setStrPersisted (key, str) {
    localStorage.setItem(key, str)
}

export function clearObj (key) {
    sessionStorage.removeItem(key)
}

export function clearObjPersisted (key) {
    localStorage.removeItem(key)
}

export function getAccessToken () {
    const user = getObj(`oidc.user:${window.oidc.userManager.settings.authority}:${window.oidc.userManager.settings.client_id}`)
    if (null == user) return null

    return user.access_token
}
